/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Poll_TimeoutInputs */

const cs_property_ai_poll_timeout = /** @type {(inputs: Property_Ai_Poll_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI návrh ještě není hotový — brzy obnovte`)
};

const en_property_ai_poll_timeout = /** @type {(inputs: Property_Ai_Poll_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI draft not ready yet — refresh shortly`)
};

/**
* | output |
* | --- |
* | "AI draft not ready yet — refresh shortly" |
*
* @param {Property_Ai_Poll_TimeoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_poll_timeout = /** @type {((inputs?: Property_Ai_Poll_TimeoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Poll_TimeoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_poll_timeout(inputs)
	return cs_property_ai_poll_timeout(inputs)
});